import { useEffect, useState } from 'react';

import { useButtonPressedCallback } from '@zenbusiness/application-commons-clickstream';
import useLocalStorage from '@zenbusiness/application-commons-hooks/useLocalStorage';
import dayjs from 'dayjs';

import { RELEASE_WHATS_NEW_SECTION } from '#client/constants/experimentsFlags';
import { ASTRA_FEATURE_BANNER } from '#client/constants/whatNewBanner';
import useConstBusinessEntityUuid from '#client/hooks/useConstBusinessEntityUuid';
import useFeatureFlag from '#client/hooks/useFeatureFlag';
import useWhatsNewBannerContext from '#client/hooks/useWhatNewBannerContext';

const useAnnouncementBanner = () => {
  const [whatsNewData, isLoadingWhatsNewData] = useFeatureFlag(RELEASE_WHATS_NEW_SECTION);
  const { businessEntityUuid } = useConstBusinessEntityUuid();
  const { removeBanner } = useWhatsNewBannerContext();

  const [isShowBanner, setShowBanner] = useState(true);
  /**
   * Store the whats_new_banner in the local storage to prevent show whats new banner
   */
  const [whatsNewBannerCache, setWhatsNewBannerCache] = useLocalStorage(
    `${ASTRA_FEATURE_BANNER.type}.${businessEntityUuid}`,
    null
  );

  const { data } = whatsNewData || {};
  const { key, title, description, pill, expiredAt, variationName } = data?.[0] || {};

  const today = dayjs();
  const endDate = dayjs(expiredAt);

  // Check if today's date is before or the same as the end date
  const isVisible = today.isBefore(endDate.add(1, 'day'));
  const shouldNotShowBanner =
    data.length === 0 ||
    !isShowBanner ||
    isLoadingWhatsNewData ||
    !isVisible ||
    whatsNewBannerCache === key;

  const buttonPressedTracker = useButtonPressedCallback({
    elementName: `close_what’snew_${variationName}`,
    elementText: 'close',
    appPageName: 'active_banking_dashboard'
  });

  const handleClose = () => {
    buttonPressedTracker();

    setWhatsNewBannerCache(key);
    setShowBanner(false);
    removeBanner(ASTRA_FEATURE_BANNER.type);
  };

  /**
   * If the new banner's key changes, the banner will be displayed again
   */
  useEffect(() => {
    if (key) {
      setShowBanner(true);
    }
  }, [key]);

  return {
    handleClose,
    shouldNotShowBanner,
    title,
    description,
    pill,
    variationName
  };
};

export default useAnnouncementBanner;
